export default "__VITE_ASSET__b54dbfeb__"